import React from 'react';
import { PricingSection } from './PricingSection';
import { footerTrust } from '../data/content';
export function FinalCta() {
  return <>
      <section className="w-full bg-ink-800 px-4 pb-6 pt-10 text-center sm:px-6 sm:pt-14" data-id="element-51" data-mp="vh0ogb251ho9">
        <div className="mx-auto max-w-2xl" data-id="element-52" data-mp="19gifkx2wp70s">
          <h2 className="text-xl font-extrabold uppercase leading-tight text-gold-500 sm:text-3xl" data-id="element-53" data-mp="15dlt2va8wqrk">
            ⏰ El precio cierra pronto
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[13px] leading-relaxed text-neutral-300 sm:text-base" data-id="element-54" data-mp="1jbk4brt9s72u">
            Con textos listos. Con planillas reales. Con protocolos para
            ejecutar hoy.
          </p>
        </div>
      </section>

      <PricingSection id="ofertas-final" compact data-id="element-55" data-mp="1o43hworyj27n" />

      <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 bg-ink-800 px-4 pb-10 text-[11px] text-neutral-400 sm:text-sm" data-id="element-56" data-mp="1o4n3qgkqaaqy">
        {footerTrust.map(item => <li key={item} data-id="element-57" data-mp="1x5uso81ctz8d">{item}</li>)}
      </ul>
    </>;
}